import React from 'react';
import { MessageCard, MessageCardSeverity } from 'azure-devops-ui/MessageCard';
import { IButtonProps } from 'azure-devops-ui/Button';

export type ErrorActionButton = { text: string; action: () => void };

export interface IWebAppErrorContext {
  message: string;
  actionButton?: ErrorActionButton;
};


export default function Error(props: IWebAppErrorContext) {
  const buttonProps: IButtonProps[] = [];
  if (props.actionButton) {
    buttonProps.push({
      text: props.actionButton.text,
      onClick: () => props.actionButton.action(),
    });
  }

  return (
    <div style={{ margin: '20px' }}>
      <MessageCard
        className='flex-self-stretch'
        severity={MessageCardSeverity.Error}
        buttonProps={buttonProps}
      >
        {props.message}
      </MessageCard>
    </div>
  );
}
